import queryString from 'query-string';
import { get } from './apiUtils';

const defaultUrl = '/UserRoles/';

export default {
  getUserRoles: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
};
